import { type VideoSegment } from '@solinkcorp/playlist-parser';
import React from 'react';
import { findClosestSegmentIndex } from 'utils/PlaylistCache/SegmentUtils';

/**
 * Given a set of SegmentData and a time, this finds the "current segment".
 *
 * This keeps track of the current segment between calls, so we don't have to search
 * for it if the time hasn't changed much.
 */
export default function useCurrentSegmentIndex(
  segments: readonly VideoSegment[] | undefined,
  time: number | undefined,
) {
  const ref = React.useRef(-1);

  const currentSegment = ref.current !== -1 ? segments?.[ref.current] : undefined;

  if (time === undefined || segments === undefined) {
    ref.current = -1;
  } else if (currentSegment && time > currentSegment.start && time <= currentSegment.end) {
    // Already on correct segment.
  } else if (
    segments &&
    ref.current === -1 &&
    time < segments[0]?.start &&
    time > segments[segments.length - 1]?.end
  ) {
    // No segments match.
  } else {
    // Find new current segment
    ref.current = findClosestSegmentIndex(segments, time);
    if (ref.current >= segments.length) {
      ref.current = -1;
    }
  }

  return ref.current === -1 ? undefined : ref.current;
}
